import { PermissionsEnum } from "@/auth/interfaces";
import {
  EstadoPreventaEnum,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
} from "@/shared";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  useCheckPermissionsArray,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
// import { TiposTextFieldNumberEnum } from '@/shared/components/ui/CustomTextFieldNumberComponente';
import {
  fetchGetPreventasCorporativos,
} from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import { IPreventaCorporativo } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import useColumnsOportunidadComercial from "../columns/useColumnsOportunidadComercial";
import { Grid } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface TableGestionOportunidadComercialFilterPlanProps {
  showCustomActionBtnSpace?: boolean;
  enableEditing?: boolean;
  tipo_plan?: string;
  // aprueba_plan_personalizado?: boolean
}

export default function TableGestionOportunidadComercialFilterPlan({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  tipo_plan = "DEMO",
}: // aprueba_plan_personalizado
TableGestionOportunidadComercialFilterPlanProps) {
  const navigate = useNavigate();
  useCheckPermissionsArray([
    PermissionsEnum.api_view_preventacoorporativa,
    PermissionsEnum.api_change_preventacoorporativa,
  ]);



  const { columnsPreventaCorporativo } = useColumnsOportunidadComercial();

  const { pagination, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: preventasCorporativas,
    isRefetching,
  } = fetchGetPreventasCorporativos({
    page: pageIndex + 1,
    page_size: pageSize,
    filterByState: false,
    tipo_plan_in: tipo_plan,
    estado_preventa_exclude: `${EstadoPreventaEnum.CANCELADO}`,
    ...filterObject,
    // aprueba_plan_personalizado: aprueba_plan_personalizado,
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaCorporativo>
            columns={columnsPreventaCorporativo}
            data={preventasCorporativas?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasCorporativas?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // // actions
            // crud
            canDelete={false}
            canEdit={true}
            positionActionsColumn="first"
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            onEdit={(row) => {
              navigate(`${ROUTER_PATHS.ventasCorporativas.preventaCorporativoEditNav}/${row.id_preventa_coorporativa}/${row.prospecto_corporativo_data?.id_prospecto_corporativo}`)
            }}
            editIcon={<Visibility/>}
          />
        </Grid>
      </Grid>
    </>
  );
}
